import { useQuery } from '@tanstack/react-query';
import { diagnosticService } from '../services';

export function useDiagnosticSchedule() {
  return useQuery({
    queryKey: ['diagnostic', 'schedule'],
    queryFn: () => diagnosticService.getSchedule(),
    staleTime: 60 * 1000,
  });
}
